// Centralized API configuration
// This ensures consistent backend URL handling across all components

/**
 * Normalize backend URL to handle various formats:
 * - undefined/empty: returns fallback
 * - with trailing slash: removes it
 * - with /api suffix: removes it
 */
const normalizeBackendBase = (rawValue) => {
  const fallback = 'http://localhost:8000';
  const raw = String(rawValue || '').trim();
  if (!raw) return fallback;
  const noTrailingSlash = raw.replace(/\/+$/g, '');
  return noTrailingSlash.replace(/\/api$/i, '');
};

export const BACKEND_BASE = normalizeBackendBase(process.env.REACT_APP_BACKEND_URL);
export const API_URL = `${BACKEND_BASE}/api`;

/**
 * Get WebSocket URL for real-time connections
 * Handles both development (ws://) and production (wss://)
 */
export const getWebSocketUrl = (path = '/api/ws') => {
  // Replace http/https with ws/wss
  const wsBase = BACKEND_BASE.replace(/^http/i, 'ws');
  return `${wsBase}${path}`;
};

/**
 * Create headers for authenticated API requests
 */
export const getAuthHeaders = (token) => ({
  'Content-Type': 'application/json',
  ...(token ? { 'Authorization': `Bearer ${token}` } : {})
});

export default {
  BACKEND_BASE,
  API_URL,
  getWebSocketUrl,
  getAuthHeaders
};
